import { useEffect, useState } from 'react';
import { useAppContext } from '../context';
import { Status, WebSocketDataReturnType } from '../../@types';

interface GetBrollMediaProgressProps {
  id: string;
  initialResourceUrl: string;
  initialResourceStatus?: string;
  type: WebSocketDataReturnType;
}

export const useGetBrollMediaProgress = ({
  id,
  initialResourceUrl,
  initialResourceStatus,
  type,
}: GetBrollMediaProgressProps) => {
  const [resourceUrl, setResourceUrl] = useState(initialResourceUrl);
  const [resourceStatus, setResourceStatus] = useState(initialResourceStatus);
  const [progressPercentage, setProgressPercentage] = useState<number>(0);

  const {
    websocket: { aiGenerateTaskMap, sendMessage },
  } = useAppContext();

  const taskMap = aiGenerateTaskMap;

  useEffect(() => {
    if (
      initialResourceStatus === Status.NotStarted ||
      initialResourceStatus === Status.InProgress
    ) {
      sendMessage({
        event: 'register',
        data: { id },
      });
    }
  }, [initialResourceStatus, sendMessage, id]);

  useEffect(() => {
    if (!id) return;

    const resData = taskMap.get(id);
    if (!resData) return;

    setProgressPercentage(resData?.progress || 0);

    switch (resData.status) {
      case Status.Success:
        setResourceUrl(resData?.data?.aiMediaData?.url);
        setResourceStatus(Status.Success);
        break;
      case Status.Error:
        setResourceUrl('');
        setResourceStatus(Status.Error);
        break;
      case Status.InProgress:
        setResourceUrl('');
        setResourceStatus(Status.InProgress);
        break;
      default:
        break;
    }
  }, [taskMap.get(id)]);

  return {
    resourceUrl,
    resourceStatus,
    progressPercentage,
  };
};
